export default class Accordion {
  constructor(btn, parentClass, cb) {
    this.btn = btn;
    this.parent = parentClass;
    this.accordionEvent = this.openAccordion.bind(this);
    this.inizialized = false;
    this.cb = cb;
  }

  openAccordion (ev) {
    let target = $(ev.target);
    if($(target).is(this.btn) || $(this.btn).find(target).length > 0) {
      let parent = $(target).closest(this.parent);
      if (!$(parent).hasClass('active')) {
        $(parent).addClass('active').siblings('.active').removeClass('active');
      } else {
        $(parent).removeClass('active');
      }

      if(this.cb) {
        setTimeout(() => {
          this.cb();
        }, 800)
      }

    }
  }

  init() {
    document.addEventListener('click',  this.accordionEvent);
    this.inizialized = true;
  }

  destroy() {
    if (this.inizialized) {
      document.removeEventListener('click', this.accordionEvent);

      $(this.btn).each((i, el) => {
        let parent = $(el).closest(this.parent);
        $(parent).removeClass('active');
      })

      this.inizialized = false;
    }
  }
}